// extracted by mini-css-extract-plugin
export default {"chunksPreviewContainer":"ChunkPreview_chunksPreviewContainer__t2MIB","empty":"ChunkPreview_empty__ItGRx","videoPlayer":"ChunkPreview_videoPlayer__c65kV"};